import { render, staticRenderFns } from "./PresubMarketingConsentComponent.vue?vue&type=template&id=4deed2f8"
import script from "./PresubMarketingConsentComponent.vue?vue&type=script&lang=ts"
export * from "./PresubMarketingConsentComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports